import type { ApiModuleEndpoints } from '../types'

export const systemSettingApiEndpoints = {
  get: {
    method: 'GET',
    path: '/settings/system',
    requiresAuth: true,
  },
  public: {
    method: 'GET',
    path: '/settings/system/public',
    requiresAuth: true,
  },
  update: {
    method: 'PUT',
    path: '/settings/system',
    requiresAuth: true,
  },
  brandingPresign: {
    method: 'POST',
    path: '/settings/system/branding/presign',
    requiresAuth: true,
  },
  brandingConfirm: {
    method: 'POST',
    path: '/settings/system/branding/confirm',
    requiresAuth: true,
  },
  brandingDelete: {
    method: 'DELETE',
    path: '/settings/system/branding/:type',
    requiresAuth: true,
  },
  smtpTest: {
    method: 'POST',
    path: '/settings/system/smtp/test',
    requiresAuth: true,
  },
  bankAccounts: {
    method: 'GET',
    path: '/settings/system/bank-accounts',
    requiresAuth: true,
  },
  bankAccountCreate: {
    method: 'POST',
    path: '/settings/system/bank-accounts',
    requiresAuth: true,
  },
  bankAccountUpdate: {
    method: 'PUT',
    path: '/settings/system/bank-accounts/:id',
    requiresAuth: true,
  },
  bankAccountDelete: {
    method: 'DELETE',
    path: '/settings/system/bank-accounts/:id',
    requiresAuth: true,
  },
  birthdayEmailHistory: {
    method: 'GET',
    path: '/settings/system/birthday-emails/history',
    requiresAuth: true,
  },
  birthdayEmailTest: {
    method: 'POST',
    path: '/settings/system/birthday-emails/test',
    requiresAuth: true,
  },
  birthdayEmailRetry: {
    method: 'POST',
    path: '/settings/system/birthday-emails/history/:id/retry',
    requiresAuth: true,
  },
} as const satisfies ApiModuleEndpoints
